export default
	[
		{
			path: '',
			redirect: 'projectManagement'
		},
		{
			path: 'projectManagement',
			name: 'projectCenter/projectManagement',
			component: () => import('@/page/projectCenter/projectManagement'),
			meta: { openKeyName: '项目中心', selectKeyUrl: 'projectManagement' }
		},
		{
			props: true,
			path: 'detail/:id',
			name: 'projectCenter/detail',
			component: () => import('@/page/projectCenter/detail'),
			props: true,
			meta: { openKeyName: '项目中心', selectKeyUrl: 'projectManagement' }
		},
	]



// WEBPACK FOOTER //
// ./src/router/projectCenter/index.js